import React from 'react'
import { ErrorIcon, ErrorMessageContainer, ErrorMessageText } from './ErrorMessageStyled'
import { ApolloError } from '@apollo/client'
import { Spacer } from '@spritz-finance/ui'

interface ErrorMessageProps {
    message: string
}

export default function ErrorMessage({ message }: ErrorMessageProps) {
    return (
        <ErrorMessageContainer>
            <ErrorIcon />
            <Spacer width={4} />
            <ErrorMessageText>{message}</ErrorMessageText>
        </ErrorMessageContainer>
    )
}

export const GraphQLErrorMessage: React.VFC<{ error: ApolloError }> = ({ error }) => {
    return <ErrorMessage message={error?.graphQLErrors[0]?.message} />
}
